export const RADIO_INPUT_GROUP_THEMES = {
  default: "default",
  button: "button"
};
